import { useEffect, useMemo, useRef, useState } from "react"
import Select_Dsas from "../Select_Dsas.js"
import useStyles from '../../styles/global-mui.js'

export const CustoSelect = ({inexistantList, existantList, onSelect, onHide, isOpen = true}) => {

    const classes = useStyles();

    const [open, setOpen] = useState(isOpen)

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, () => {setOpen(false); onHide()});

    const combinedItems = useMemo(() => {
        if(existantList && existantList.length)
            return [
                { title: "Disponibles", items: inexistantList },
                { title: "Déjà présents", items: existantList },
            ];

        return [
            { title: "Disponibles", items: inexistantList },
          ];
    }, [inexistantList, existantList])


    return <>
        <Select_Dsas 
                    inputRef={wrapperRef}   
                    // sx={{position : 'absolute', right : 0, width : 300}}
                    className={classes.customInput}
                    fullWidth
                    label = {"Player"}
                    name = {"player"}
                    value = {""}
                    items={combinedItems.flatMap(({ title, items }) => [
                        { _id: title, name: title, disabled: true },
                        ...items,
                      ])}
                    open={open}
                    onChange = {(e) => {onSelect(e.target.value) ; setOpen(false); onHide() }}
                    onClick = {(e) => {e.stopPropagation() ; setOpen(true)}}
                />
    </>
    
    
}

export const CustoFlatSelect = ({inexistantList, existantList, onSelect, value, idx, name, label, editing, editingValue, onChangeEditing}) => {

    const classes = useStyles();

    const combinedItems = useMemo(() => {
        if(existantList && existantList.length)
            return [
                { title: "Disponibles", items: inexistantList },
                { title: "Déjà présents", items: existantList },
            ];

        return [
            { title: "Disponibles", items: inexistantList },
          ];
    }, [inexistantList, existantList])

    return <Select_Dsas    
        className={classes.customInput}
        fullWidth
        label = {label}
        name = {name}
        value = {value}
        items = {combinedItems.flatMap(({ title, items }) => [
            { _id: title, name: title, disabled: true },
            ...items,
          ])}
        onChange = {(e) => onSelect(e.target.value)}
        editing={editing}
        editingValue={editingValue}
        onChangeEditing={onChangeEditing}

    />
}

function useOutsideAlerter(ref, callback) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && event.target.tagName !== 'LI') {
            callback()
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}